import { ChangeEvent, FC, HTMLAttributes } from "react";
import { ReactComponent as SearchIcon } from "../../../images/SearchIcon.svg";
import styles from "./Search.module.sass";

interface SearchProps extends HTMLAttributes<HTMLDivElement> {
	placeholder?: string;
	value: string;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const Search: FC<SearchProps> = ({ className, placeholder = "Поиск", value, onChange }) => {
	return (
		<div className={styles.form + " " + className}>
			<input value={value} onChange={onChange} type="text" className={styles.search} placeholder={placeholder} />
			<button type="submit" className={styles.btn}>
				<SearchIcon className={styles.icon} />
			</button>
		</div>
	);
};

export default Search;
